const entity = 'kennels'
const entitySingle = 'kennel'
const tableIcon = 'cil-house'

export {
  entity,
  entitySingle,
  tableIcon
}
